import { render, staticRenderFns } from "./BasicInfoRow.vue?vue&type=template&id=6c34f412&scoped=true&"
import script from "./BasicInfoRow.vue?vue&type=script&lang=js&"
export * from "./BasicInfoRow.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoRow.vue?vue&type=style&index=0&id=6c34f412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34f412",
  null
  
)

export default component.exports